<!--
卡

使用说明：

<CardItem
    :card="{Card}"
/>

Card={
    }
-->
<template>
  <div>
    <div class="card-wrap head-menu">
      <div class="topbar" v-if="controlType == 0">
        <template v-for="(item, index) in menu">
          <div class="filter-btn" :class="{'active': item.active}" @click="toggleFilterBtn(item)">
            <div class="btn-text">
              {{item.name}}
              <span class="filter-btn-icon"></span>
            </div>
          </div>
        </template>

        <div class="info" @click="handleControl(1)">
          <span>管理</span>
        </div>
      </div>
      <div class="topbar edit" v-if="controlType == 1">
        <div class="info">
          共
          <span class="sum-num">{{count ? count : 0}}</span> 张卡
        </div>

        <div class="info" @click="handleControl(0)">
          <span>完成</span>
        </div>
      </div>

      <div class="filter-ctn" :class="{'show': isFilterCtnShow}">
        <div class="filter-wrap">
          <template v-if="menuType == 1">
            <div class="filter-list show">
              <button
                class="filter-cond"
                v-for="item in openStatusList"
                @click="handleSelectOpenStatus(item)"
                :class="{'active': item.selected}"
              >{{item.name}}</button>
            </div>
          </template>
          <template v-else-if="menuType == 2">
            <div class="filter-list show">
              <button
                class="filter-cond"
                v-for="item in selectTypes"
                @click="handleSelectSelectTypes(item)"
                :class="{'active': item.selected}"
              >{{item.name}}</button>
            </div>
          </template>
          <template v-else>
            <div class="filter-list show">
              <div class="start-select">
                <div>
                  <p>开始时间：</p>
                </div>
                <div>
                  <el-date-picker type="date" v-model="selectedData.start" :picker-options="disabled"  placeholder="请选择开始时间" style="width: 60vw"></el-date-picker>
                </div>
              </div>
              <div class="end-select">
                <div>
                  <p>结束时间：</p>
                </div>
                <div>
                  <el-date-picker type="date" v-model="selectedData.end"  :picker-options="disabled"  placeholder="请选择结束时间" style="width: 60vw"></el-date-picker>
                </div>
              </div>
              <div class="quick-select">
                <div>
                  <p>快捷时间段：</p>
                </div>
                <div class="quick-date">
                  <span @click="thisDay(1)" :class="{active : isActive == 1}">今天</span>
                  <span @click="thisWeek(2)" :class="{active : isActive == 2}">本周</span>
                  <span @click="thisMonth(3)" :class="{active : isActive == 3}">本月</span>
                </div>
              </div>
            </div>
          </template>

          <div class="filter-actions">
            <button class="btn-left" @click="reset">重置</button>
            <button class="btn-right" @click="handleSearch">确定</button>
          </div>
        </div>

        <div class="mask" @click="closeMask()"></div>
      </div>
    </div>

    <div class="card-wrap foot-menu" v-if="controlType == 1">
      <van-checkbox
        v-model="checked"
        checked-color="#4b0"
        style="margin-left: 5vw"
        @change="handleSelectAll"
      >全选</van-checkbox>
      <van-button size="small" type="danger" style="margin-right: 5vw" @click="handleDelete">删除</van-button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import { transferTimeShort, transferTime } from "../../tools/time/time";
// import 'iview/dist/styles/iview.css'

export default {
  props: ["count", "controlType"],
  components: {},
  data() {
    return {
      startTimeShow: false,
      endTimeShow: false,
      disabled: {
        disabledDate: function(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      isActive: "",
      checked: false,
      menuType: "",
      menu: [
        {
          name: "使用情况",
          type: 1,
          active: false
        },
        {
          name: "卡类型",
          type: 2,
          active: false
        },
        {
          name: "领用时间",
          type: 3,
          active: false
        }
      ],

      // 使用情况
      openStatusList: [
        { type: "", name: "全部", selected: true },
        { type: 0, name: "未刮卡", selected: false },
        { type: 1, name: "已刮卡", selected: false }
      ],

      // 卡类型
      selectTypes: [{ code: "", name: "全部", selected: true }],

      cardTotal: 0,

      selectedData: {
        status: "",
        type: "",
        start: "",
        end: "",
        startDate: "",
        endDate: ""
      }
    };
  },
  computed: {
    isFilterCtnShow: function() {
      var isShow = false;
      for (var i = 0; i < this.menu.length; i++) {
        var f = this.menu[i];
        if (f.active) {
          isShow = true;
          break;
        }
      }
      return isShow;
    }
  },
  methods: {
    showTime(t) {
      if (t == 0) {
        this.startTimeShow = true;
        this.endTimeShow = false;
      } else {
        this.startTimeShow = false;
        this.endTimeShow = true;
      }
    },
    toggleFilterBtn(item) {
      for (var i = 0; i < this.menu.length; i++) {
        var f = this.menu[i];
        f.active = false;
      }
      this.menuType = item.type;
      item.active = true;
    },
    handleSelectOpenStatus(item) {
      for (var i = 0; i < this.openStatusList.length; i++) {
        var f = this.openStatusList[i];
        f.selected = false;
      }
      item.selected = true;

      this.selectedData.status = item.type;
    },
    handleSelectSelectTypes(item) {
      for (var i = 0; i < this.selectTypes.length; i++) {
        var f = this.selectTypes[i];
        f.selected = false;
      }
      item.selected = true;

      this.selectedData.type = item.code;
    },
    closeMask() {
      for (var i = 0; i < this.menu.length; i++) {
        var f = this.menu[i];
        f.active = false;
      }
    },

    // 获取卡类型
    getSelectTypes() {
      api.wallet.getSelectTypes(this.getSelectTypesOkCb);
    },
    getSelectTypesOkCb(data) {
      for (let i = 0; i < data.selectTypes.length; i++) {
        var f = data.selectTypes[i];
        f["selected"] = false;
        this.selectTypes.push(f);
      }
    },
    closeSelected() {
      for (let i = 0; i < this.menu.length; i++) {
        this.menu[i].active = false;
      }
    },
    reset() {
      for (let i = 0; i < this.openStatusList.length; i++) {
        let o = this.openStatusList[i];
        if (i == 0) {
          o.selected = true;
        } else {
          o.selected = false;
        }
      }

      for (let i = 0; i < this.selectTypes.length; i++) {
        let o = this.selectTypes[i];
        if (i == 0) {
          o.selected = true;
        } else {
          o.selected = false;
        }
      }

      this.selectedData.status = "";
      this.selectedData.type = "";
      this.selectedData.start = "";
      this.selectedData.end = "";
      this.selectedData.startDate = "";
      this.selectedData.endDate = "";
      this.closeSelected();
    },

    handleSearch() {
      this.closeSelected();
      this.selectedData.startDate = this.selectedData.start
        ? new Date(this.selectedData.start).format("yyyy-MM-dd")
        : "";
      this.selectedData.endDate = this.selectedData.end
        ? new Date(this.selectedData.end).format("yyyy-MM-dd")
        : "";
      this.$emit("handleSelected", this.selectedData);
    },

    // 卡编辑
    handleControl(type) {
      this.controlType = type;
      if (type == 0) {
        this.checked = false;
      }
      this.$emit("handleControl", type);
    },
    handleSelectAll(type) {
      this.$emit("handleSelectAll", type);
    },
    handleDelete() {
      this.$emit("handleDelete");
    },
    thisDay(type) {
      this.isActive = type;
      var now = new Date().getTime();
      var st = transferTimeShort(now);
      var et = transferTime(now);
      this.selectedData.start = st;
      this.selectedData.end = et;
    },
    thisWeek(type) {
      this.isActive = type;
      var now = new Date().getTime();
      var day = new Date().getDay();
      if (day == 0) {
        var range = 24 * 60 * 60 * 1000 * 6;
      } else {
        var range = 24 * 60 * 60 * 1000 * day - 24 * 60 * 60 * 1000;
      }
      var st = transferTimeShort(now - range);
      var et = transferTime(now);
      this.selectedData.start = st;
      this.selectedData.end = et;
    },
    thisMonth(type) {
      this.isActive = type;
      var now = new Date().getTime();
      var day = new Date().getDate();
      var range = 24 * 60 * 60 * 1000 * day - 24 * 60 * 60 * 1000;
      var st = transferTimeShort(now - range);
      var et = transferTime(now);
      this.selectedData.start = st;
      this.selectedData.end = et;
    }
  },
  mounted() {
    this.getSelectTypes();
  }
};
</script>

<style scoped lang="less">
@import "../../tools/time/time.less";

html {
  background: #f3f1f2;
}
.static-box {
  height: 12vw + 2.933vw;
}

.topbar {
  // position: fixed;
  height: 11.4666vw;
  background: #fff;
  // top: 0;
  // left: 0;
  // right: 0;
  z-index: 10;
  padding-left: 3.2vw;
  padding-right: 3.2vw;
  border-bottom: 1px solid #ddd;
  margin-bottom: 2vw;
}

.topbar .info {
  line-height: 11.4666vw;
  color: #333;
  font-size: 3.733vw;
  text-align: right;
}

.topbar .info .sum-num {
  color: #fe3233;
}

.filter-btn {
  color: #3b3b3b;
  line-height: 11.4666vw;
  float: left;
  margin-left: 6.066vw;
  font-size: 3.733vw;
}

.filter-btn .filter-btn-icon {
  background-image: url(//res.uuudian.com/hk_data/c5d0db29-e907-45e3-bfb7-0579ca470f4c);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 1.9vw;
  height: 1.9vw;
  display: inline-block;

  transition: all 0.3s ease;

  transform: rotate(0deg);
}

.filter-btn.active {
  position: relative;
}

.filter-btn .btn-text {
  position: relative;
  z-index: 2;
}

.filter-btn.active:after {
  content: "";
  display: block;
  background: white;
  position: absolute;

  bottom: 0;
  top: 0.8vw;
  right: -2.5vw;
  left: -2.5vw;
  z-index: 1;

  height: 10.54vw;

  border: 1px solid #ddd;
  border-bottom: none;
  border-top-left-radius: 0.66vw;
  border-top-right-radius: 0.66vw;
}

.filter-btn.active .filter-btn-icon {
  transform: rotate(180deg);
}

.filter-ctn {
  display: none;
}

.filter-ctn.show {
  display: block;
}

.filter-ctn .mask {
  z-index: 9;
}

.filter-wrap {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  border-top: 1px solid #ddd;
}

.filter-list {
  padding: 2.66vw;
  display: none;
}

.filter-list.show {
  display: block;
}

.filter-cond {
  background: #f0f0f0;
  color: #333;
  font-size: 3.3vw;
  border: none;
  text-align: center;
  line-height: 8vw;
  width: 29.33vw;
  border: 1px solid #f0f0f0;
  border-radius: 0.4vw;
  margin: 1.33vw 1.066vw;
}

.filter-cond.active {
  background: #fff;
  border-color: #fe3233;
  color: #fe3233;
}

/*
.filter-cond.active:before{
    content: '';
    background-image: url(//resource.uwan99.com/hk_data/e965159d-9272-4a4f-930f-b34047ee59a2);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    display: inline-block;
    width: .8em;
    height: .8em;
    margin-right: .3em;
    margin-bottom: -0.2vw;
}
*/

.filter-actions {
  font-size: 0;
}

.filter-actions .btn-left {
  background: #fff;
  color: #333;
  font-size: 4vw;
  border: none;
  text-align: center;
  line-height: 9.333vw;
  width: 50vw;
  border-top: 1px solid #ddd;
}
.filter-actions .btn-right {
  background: #fe3233;
  color: #fff;
  font-size: 4vw;
  border: none;
  text-align: center;
  line-height: 9.333vw;
  width: 50vw;
  border-top: 1px solid #fe3233;
}

.mask {
  z-index: 9;
  background: #000;
  opacity: 0.6;
}

// 卡编辑
.head-menu {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

.topbar.edit {
  display: flex;
  justify-content: space-between;
}
.foot-menu {
  position: fixed;
  bottom: 0;
  z-index: 999;
  background: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2vw 0;
}
</style>





// WEBPACK FOOTER //
// src/components/orders/CardFilter.vue